import React from 'react';
import '../../css/SaveLoading.css';

const SaveLoading = () => (
    <div className="saveLoadingContainer">      
        <span className="saveLoadingIcon" />
    </div>
);

export default SaveLoading;